module.exports = __webpack_public_path__ + "static/media/message_animation.65557ac2.gif";